import {
  $applyNodeReplacement,
  EditorConfig,
  ElementNode,
  NodeKey,
  SerializedElementNode,
} from "lexical";

import { addClassNamesToElement } from "@lexical/utils";

export type SerializedCustomTableBlockNode = SerializedElementNode;

export class CustomTableBlockNode extends ElementNode {
  __isScrollable: boolean;

  static getType(): string {
    return "custom-table-block";
  }

  static clone(node: CustomTableBlockNode): CustomTableBlockNode {
    return new CustomTableBlockNode(node.__isScrollable, node.__key);
  }

  static importJSON(
    _serializedNode: SerializedCustomTableBlockNode
  ): CustomTableBlockNode {
    return $createTableBlockNode();
  }

  constructor(isScrollable: boolean, key?: NodeKey) {
    super(key);
    this.__isScrollable = isScrollable;
  }

  exportJSON(): SerializedElementNode {
    return {
      ...super.exportJSON(),
      type: "custom-table-block",
      version: 1,
    };
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = document.createElement("div");
    const classes = [config.theme.tableBlock];
    if (this.__isScrollable) {
      classes.push(config.theme.tableBlockScrollable);
    }
    addClassNamesToElement(dom, ...classes);

    return dom;
  }

  updateDOM(): boolean {
    return false;
  }

  getIsScrollable(): boolean {
    return this.__isScrollable;
  }
}

export function $createTableBlockNode(
  isScrollable: boolean = false
): CustomTableBlockNode {
  return $applyNodeReplacement(new CustomTableBlockNode(isScrollable));
}
